export enum PublicPages {
    COMPANY_REGISTRATION = 'company-registration',
    CONTACT = 'contact',
    OIDC_LOGIN = 'oidc/login',
    NEWS = 'news',
}

export enum Params {
    ID = 'id',
    NEWSID = 'newsId',
    REGISTRATION_ID = 'registrationId',
    PRODUCT_ID = 'productId',
    FORMULATION_ID = 'formulationId',
    PRODUCT_APPROVAL_ID = 'productApprovalId',
}

export enum AdminPages {
    ADMIN = 'admin',
    MASTER_DATA_EDIT = 'master-data-edit',
    MASTER_DATA_NEW = 'master-data-new',
    PRODUCTS = 'products',
    PRODUCTS_OVERVIEW = 'products-overview',
    PROCESSES_OVERVIEW = 'processes-overview',
    TEST_AGGREGATES = 'test-aggregates',
    TEST_AGGREGATES_OIL_TESTING_ENGINE_TESTS = 'oil-testing-engine-tests',
    TEST_AGGREGATES_OIL_TESTING_ENGINE_TESTS_NEW = 'oil-testing-engine-tests-new',
    TEST_AGGREGATES_OIL_TESTING_ENGINE_TESTS_TEST_DETAILS = 'test-details',
    TEST_AGGREGATES_OIL_TESTING_ENGINE_MASTER_DATA = 'oil-testing-engine-master-data',
    ENGINE_TYPES_EDIT = 'engine-types-edit',
    TEST_STAND_EDIT = 'test-stand-endit',
    TEST_SUBSTANCES_EDIT = 'test-substances-endit',
    INVOICE_DATA_EDIT = 'invoice-data-endit',
    TEST_BENCH_RESULTS_EDIT = 'test_bench-results-endit',
    ENGINE_TYPES_NEW = 'engine-types-new',
    TEST_STAND_NEW = 'test-stand-new',
    TEST_SUBSTANCES_NEW = 'test-substances-new',
    INVOICE_DATA_NEW = 'invoice-data-new',
    TEST_BENCH_RESULTS_NEW = 'test_bench-results-new',
    CLIENT = 'client',
    CLIENT_REG_DETAILS = 'registration-details',
    CLIENT_REG_MANAGE = 'registration-manage',
    CLIENT_REG_CHANGE = 'registration-change',
    CLIENT_INVOICES = 'invoices',
    MASTER_DATA = 'master-data',
    MASTER_DATA_SHEETS = 'sheets',
    MASTER_DATA_COMPATIBLE_SHEETS = 'compatible_sheets',
    MASTER_DATA_COSTS = 'costs',
    MASTER_DATA_SALES_AREAS = 'sales-areas',
    MASTER_DATA_QUALITY_LINES = 'quality-lines',
    MASTER_DATA_OPERATING_FLUID_TYPES = 'operating-fluid-types',
    MASTER_DATA_SAE_CLASSES = 'sae-classes',
    MASTER_DATA_MB_SPECIFICATIONS = 'mb-specifications',
    MASTER_DATA_ADDITIVE = 'additive',
    MASTER_DATA_MANAGE_TESTS = 'manage-tests',
    MASTER_DATA_MANAGE_TEST_PARAMETERS = 'manage-test-parameters',
    MASTER_DATA_BASE_OILS = 'base-oils',
    MASTER_DATA_CONTAINER_SIZE = 'container-size',
    MASTER_DATA_SHEET_CARE = 'sheet-care',
    MASTER_DATA_PRODUCT_CARE = 'product-care',
    MASTER_DATA_TEST_CARE = 'test-care',
    MASTER_DATA_AREA_CARE = 'area-care',
    MASTER_DATA_ADDITIVE_BASEOIL_CARE = 'additive-baseoil-care',
    DASHBOARD = 'dashboard',
    MANAGEMENT = 'management',
    MANAGEMENT_NEWS = 'news',
    MANAGEMENT_NEWS_CREATE = 'news-create',
    MANAGEMENT_NEWS_EDIT = 'news-edit',
    MANAGEMENT_SERVICE_AREA = 'service-area',
    MANAGEMENT_SERVICE_AREA_NEW = 'service-area-new',
    MANAGEMENT_SERVICE_AREA_EDIT = 'service-area-edit',
    EXTERNAL_APPLICATIONS = 'external-applications',
    EXTERNAL_APPLICATIONS_OPERATING_FLUID_WEBSITE = 'operating-fluid-website',
    EXTERNAL_APPLICATIONS_BMATERIAL_API = 'bmaterial-api',
    EXTERNAL_APPLICATIONS_FLUIDFINDER = 'fluidfinder',
    EXTERNAL_APPLICATIONS_FUELS_DB = 'fuels-db',
    MANAGEMENT_FAQ_EDIT = 'faq-edit',
    MANAGEMENT_FAQ_NEW = 'faq-new',
    MASTER_DATA_SUBSTANCE_TYPE = 'type',
}

//Pages with content
export enum ClientPages {
    MY_COMPANY = 'my-company',
    PRODUCT = 'product',
    PRODUCT_NEW = 'product-new',
    PRODUCT_FORMULATION_NEW = 'product-formulation-new',
    SERVICE = 'service',
    OILTESTENGINES = 'oil-test-engines',
}

//Pages without content, if accessed, NotFoundRoute will be shown
export enum ClientWrapperPages {
    USER = 'user',
    DASHBOARD = 'dashboard',
    PRODUCT_FORMULATION_EDIT = 'product-formulation-edit',
    PRODUCT_APPROVAL_DETAILS = 'product-approval-details',
    PRODUCT_EDIT = 'product-edit',
}
